export const skills = [
  {
    id: 1,
    category: 'Core Skills',
    items: [
      'Software Engineering',
      'System Architecture',
      'Problem Solving',
      'Technical Leadership',
    ],
  },
  {
    id: 2,
    category: 'Cloud Architecture',
    items: ['AWS', 'Firebase', 'Microservices', 'Serverless'],
  },
  {
    id: 3,
    category: 'Machine Learning & Deep Learning',
    items: ['TensorFlow', 'PyTorch', 'NLP', 'Computer Vision', 'Reinforcement Learning'],
  },
  {
    id: 4,
    category: 'Full-Stack Development',
    items: ['React', 'Node.js', 'Django', 'Java', 'PostgreSQL'],
  },
  {
    id: 5,
    category: 'Cybersecurity & Network Engineering',
    items: ['Network Security', 'Cisco Networking', 'Fortinet', 'Security Architecture'],
  },
  {
    id: 6,
    category: 'DevOps & CI/CD',
    items: ['Docker', 'Kubernetes', 'GitHub Actions', 'CI/CD Pipelines'],
  },
  {
    id: 7,
    category: 'Software Architecture & Optimization',
    items: ['System Design', 'Performance Optimization', 'Scalability', 'Enterprise Architecture'],
  },
  {
    id: 8,
    category: 'Project Management',
    items: ['Agile Methodologies', 'Team Leadership', 'Product Roadmaps', 'Stakeholder Management'],
  },
  {
    id: 9,
    category: 'Technical Writing & Research',
    items: ['Research Papers', 'Technical Documentation', 'Academic Writing', 'Knowledge Transfer'],
  },
  {
    id: 10,
    category: 'Mobile Development',
    items: ['Android', 'Kotlin', 'Jetpack Compose', 'Material Design'],
  },
  {
    id: 11,
    category: 'Backend & APIs',
    items: ['Spring Boot', 'RESTful APIs', 'API Design', 'Authentication & Authorization'],
  },
  {
    id: 12,
    category: 'Data & Messaging',
    items: ['SQL', 'NoSQL', 'Event-Driven Architectures', 'Message Queues'],
  },
];
